import React from 'react';
import {Link} from 'react-router-dom';

export default function Footerheading() {
    return (
        <h1 className="logo">
            <a href="/">InfoMine</a>
            </h1>

    )
}
